<template>
    <div class="container">
      <b-form @submit="onSubmit" class="login-form">
        <b-form-group  label="E-Mailadresse:" label-for="email">
          <b-form-input
            id="email"
            v-model="form.email"
            type="email"
            required
            placeholder=""
            :class="authenticationError ? 'is-invalid' : ''"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Passwort:" label-for="password">
          <b-form-input
            id="password"
            v-model="form.password"
            type="password"
            required
            placeholder=""
            :class="authenticationError ? 'is-invalid' : ''"
          ></b-form-input>
          
          <div class="invalid-feedback" v-if="authenticationError">{{ authenticationError }}</div>
        </b-form-group>

        
        <b-button type="submit" variant="primary" :disabled="authenticating" class="btn-block mt-4">
            <span v-if="!authenticating" class="d-flex align-items-center justify-content-between"><font-awesome-icon :icon="['far', 'arrow-right']" style="opacity: 0" />Jetzt anmelden<font-awesome-icon :icon="['far', 'arrow-right']" /></span>
            <span v-else><b-spinner small type="grow"></b-spinner> Du wirst eingeloggt...</span>
        </b-button>

        <b-link :to="{name: 'reset-pw'}" class="d-block text-center mt-3">Passwort vergessen</b-link>
        <!-- <b-button variant="primary" class="btn-block mt-3" disabled v-if="!authenticating">
          <b-spinner small type="grow"></b-spinner>
          verifying your details...
        </b-button> -->
      </b-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'login',

    data() {
        return {
            form: {
                email: process.env.NODE_ENV == 'development' ? "mayospacken@googlemail.com" : '',
                password: process.env.NODE_ENV == 'development' ? "pMuH6W3F" : '',
            }
        };
    },

    computed: {
        ...mapGetters('auth', [
            'authenticating',
            'authenticationError',
            'authenticationErrorCode'
        ])
    },

    methods: {
        ...mapActions('auth', [
            'login'
        ]),

        onSubmit(e) {
            e.preventDefault()
            if (this.email != '' && this.password != '') {
                this.login({email: this.form.email, password: this.form.password})
                this.password = ''
            }
        }
    }
}
</script>

<style scoped>
.login-form {
    padding-top: 30px;
}
</style>